module.exports = "/images/bg_story_banner_2.jpg?75021ba24c3c6f3365c63c2c904a597e";